export default __webpack_public_path__ + "images/9R.0107896.png";